export default "__VITE_ASSET__439c2c2e__"